import React from "react"
import "./TimeField.css"
import { ClockIcon, CloseIcon } from "../../Icons"

class TimeFieldOption extends React.Component {
  handleClick = () => {
    const { onClick, value } = this.props
    onClick(value)
  }

  render() {
    const { label } = this.props
    return <li onClick={this.handleClick}>{label}</li>
  }
}

class TimeField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shown: false
    }
    this.ref = React.createRef()
  }

  handleClickOutside = e => {
    if (
      this.ref.current !== e.path[0] &&
      !this.ref.current.contains(e.path[0])
    ) {
      this.setState(state => ({
        ...state,
        shown: false
      }))
    }
  }

  handleClick = () => {
    this.setState({
      shown: !this.props.disabled && !this.state.shown
    })
  }

  onClickMeridiem = meridiem => {
    this.setState({
      time: {
        meridiem: meridiem
      }
    })
  }

  selectOption = option => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    setFieldValue(name, option)
    setFieldTouched(name)
    this.setState({ shown: false })
  }

  getOptionLabel = () => {
    const selectedOption = this.props.options.find(
      option => option.value === this.props.value
    )
    const label =
      (selectedOption && selectedOption.label) || this.props.defaultValue.label
    return label
  }

  clearTime = () => {
    const { name } = this.props.field
    const { setFieldValue } = this.props.form
    setFieldValue(name, "")
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }
  render() {
    const {
      field,
      form: { touched, errors }
    } = this.props

    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (touched[field.name] && field.value && !errors[field.name]) {
      status = "is-fixed"
    }

    const winHeight = window.innerHeight
    const { bottom } =
      (this.ref.current && this.ref.current.getBoundingClientRect()) || 0

    return (
      <div
        className={`TimeField ${this.state.shown ? "shown" : ""} ${status} ${
          this.props.disabled ? "disabled" : ""
        } 
          ${winHeight - bottom < 260 ? "up" : "down"}`}
        ref={this.ref}
      >
        <span className="blankInput" onClick={this.handleClick}>
          {this.getOptionLabel()}
          <span className="clock">
            <ClockIcon />
          </span>
        </span>
        {field.value &&
          !this.props.disabled && (
            <span className="clear-time" onClick={this.clearTime}>
              <CloseIcon />
            </span>
          )}
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
        <div className="TimeField-options">
          <ul>
            {this.props.options.map((option, i) => (
              <TimeFieldOption
                key={i}
                onClick={this.selectOption}
                value={option.value}
                label={option.label}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default TimeField
